import axios from 'axios';
import MSALInstance from '@/auth/auth';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(async (config) => {
    // config.headers['X-No-Cache'] = true;
    const { userId, msalConfig, loginRequest } = MSALInstance;
    if (userId) {
        loginRequest.account = msalConfig.getAccountByHomeId(userId);
        try {
            const response = await msalConfig.acquireTokenSilent(loginRequest);
            config.headers['Authorization'] = `Bearer ${response.accessToken}`;
        } catch (e) {
            if (e instanceof InteractionRequiredAuthError) {
                const response = await msalConfig.acquireTokenRedirect(loginRequest);
                config.headers['Authorization'] = `Bearer ${response.accessToken}`;
            }
        }
    }
    return config;
});

export default axiosInstance;
